import { TestTypes } from '@hawkindynamics/core-client';
import sortBy from 'lodash/sortBy';
import { BehaviorSubject, Observable } from 'rxjs';
import { ITestType } from '../types';

const PROD_TEST_TYPES = [
  TestTypes.TEST_TYPES.CMJ.id,
  TestTypes.TEST_TYPES.DROP.id,
  TestTypes.TEST_TYPES.DROP_LANDING.id,
  TestTypes.TEST_TYPES.FREE.id,
  TestTypes.TEST_TYPES.ISO.id,
  TestTypes.TEST_TYPES.MULTI.id,
  TestTypes.TEST_TYPES.REBOUND.id,
  TestTypes.TEST_TYPES.SQUAT.id,
  TestTypes.TEST_TYPES.TS_FREE.id,
  TestTypes.TEST_TYPES.TS_ISO.id,
  TestTypes.TEST_TYPES.WEIGH_IN.id,
  TestTypes.TEST_TYPES.TS_STRIKE.id,
  TestTypes.TEST_TYPES.TS_MULTI_STRIKE.id,
];

const testTypes$ = new BehaviorSubject<ITestType[]>(
  sortBy(TestTypes.TEST_TYPES, 'name').filter((testType: ITestType): boolean =>
    PROD_TEST_TYPES.includes(testType.id)
  )
);

/**
 * @description provides hot observable of test types
 * @returns testTypes
 */
export const testTypesProvider = (): Observable<ITestType[]> => testTypes$;

export const getTestTypeLabel = (id: string): string => {
  const type = TestTypes.getTestTypeById(id);
  return type.name;
};
